import { useState, useMemo, useEffect } from "react";
import { dentalIcons } from "../../../../../../dentail-indetifcation/utils-icons/dentalIcons";
import { parseStageDescription } from "../../../../../../helper";

const MatchTeethStageTable = ({ matchedStages = [], onDelete, onTabClick }) => {
  const [selectedMethodId, setSelectedMethodId] = useState(
    matchedStages.length > 0 ? matchedStages[0].method.id : null
  );

  useEffect(() => {
    if (matchedStages.length > 0) {
      setSelectedMethodId((prev) => {
        const exists = matchedStages.some((m) => m.method.id === prev);
        return exists ? prev : matchedStages[0].method.id;
      });
    }
  }, [matchedStages]);

  const selectedMethod = useMemo(() => {
    const match = matchedStages.find((m) => m.method.id === selectedMethodId);
    return match || matchedStages[0] || null;
  }, [matchedStages, selectedMethodId]);

  const handleTabClick = (methodId) => {
    setSelectedMethodId(methodId);
    onTabClick?.(methodId); // Call parent callback if provided
  };

  return (
    <div className="match_stage_table_container">
      <div className="match_stage_table_body">
        <div className="_header">
          <p>Preview Selections</p>
        </div>

        <div className="_main">
          {matchedStages.length > 0 && (
            <div className="method_tabs">
              {matchedStages.map(({ method, index }) => (
                <div
                  key={index}
                  className={`method_tab ${
                    method.id === selectedMethodId ? "active" : ""
                  }`}
                  onClick={() => handleTabClick(method.id)}
                >
                  {method.title}{" "}
                  <span className="tooth-count">{method.teeth?.length}</span>
                </div>
              ))}
            </div>
          )}

          <div className="_table">
            <div className="header">
              <span className="secondColumn">Tooth Position</span>
              <span className="thirdColumn">Tooth Name</span>
              <span className="fistColumn">Stage Diagram</span>
              <span className="fourthColumn">Stage Information</span>
              <span className="lastColumn">Action</span>
            </div>

            {selectedMethod ? (
              selectedMethod.teeth && selectedMethod.teeth.length > 0 ? (
                selectedMethod.teeth.map((tooth, index) => {
                  const { title, description } = parseStageDescription(
                    tooth.stage?.description
                  );

                  return (
                    <div className="body" key={index}>
                      <div className="stage">
                        <p>
                          ISO{" "}
                          {tooth?.tooth_number
                            ? tooth?.tooth_number
                            : tooth.tooth_identifier}
                        </p>
                      </div>
                      <div className="stage">
                        <p>{tooth.name}</p>
                      </div>
                      <div className="diagram">
                        <div className="image-container">
                          <img
                            src={tooth.stage?.diagram || "/placeholder.svg"}
                            alt={title || "Stage Diagram"}
                            className="diagram-image"
                            onError={(e) => (e.target.src = "/placeholder.svg")}
                          />
                        </div>
                      </div>
                      <div className="stage">
                        <p>{title || "No description available"}</p>
                        <span>Matched</span>
                      </div>
                      <div className="action">
                        <img
                          src={dentalIcons.binIcon || "/placeholder.svg"}
                          alt="Delete"
                          onClick={() =>
                            onDelete(selectedMethod.method.id, tooth.id)
                          }
                        />
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no_data">
                  <p>No stages found for this method</p>
                </div>
              )
            ) : (
              <div className="no_data">
                <p>No stage match yet</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchTeethStageTable;
